import { FC } from 'react';
import MarketBasedTable from './marketBasedAndMaximum/marketBased.component';
import InvestorBased from './investorBased/investorBased.component';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  useLiquidationRiskOverviewPageModel,
  type LiquidationRiskOverviewPageModel,
} from '../../../../api/rs-hg/liquidity/hooks/queries';
import type { IMaxmimumOneDayServerData } from './marketBasedAndMaximum/maximum.data';

export type { LiquidationRiskOverviewPageModel };

export type LiquidationRiskOverviewPayload = IMaxmimumOneDayServerData & {
  selected_position_date: string;
};

const LiquidationRiskOverview: FC<FundInfoComponentProps> = (props) => {
  const { fundId, positionDate, section } = props;

  const overviewQuery = useLiquidationRiskOverviewPageModel(
    fundId,
    positionDate,
  );

  return (
    <QueryBoundary<IMaxmimumOneDayServerData>
      isLoading={overviewQuery.isLoading}
      isFetching={overviewQuery.isFetching}
      isError={overviewQuery.isError}
      error={overviewQuery.error}
      data={overviewQuery.data?.data}
      loadingMessages={['Loading liquidation risk overview…']}
      noDataMessage="No liquidation risk overview data available."
    >
      {(pageData) => {
        const overviewPayload: LiquidationRiskOverviewPayload = {
          ...pageData,
          selected_position_date:
            overviewQuery.data?.selected_position_date ??
            overviewQuery.data?.returned_position_date ??
            '',
        };

        return (
          <>
            <MarketBasedTable
              overviewPayload={overviewPayload}
              isFetching={overviewQuery.isFetching}
            />
            <InvestorBased
              section={section}
              overviewPayload={overviewPayload}
              isFetching={overviewQuery.isFetching}
            />
          </>
        );
      }}
    </QueryBoundary>
  );
};

export default LiquidationRiskOverview;
